<template>
  <div id="app" class="site-shell">
    <header class="site-header">
      <div class="brand">
        <span class="brand-cn">POSITIVE UP PTE. LTD.</span>
        <span class="brand-en">Singapore · UEN 202643218C</span>
      </div>
      <nav class="site-nav">
        <router-link to="/" exact>Home</router-link>
        <router-link to="/about">About Us</router-link>
      </nav>
    </header>
    <main class="site-main" :class="{ 'is-flush': $route.name === 'home' }">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="footer-info">
        <span class="footer-name">© 2026 POSITIVE UP PTE. LTD.</span>
        <span class="footer-meta">Country / Region of Registration: Singapore</span>
        <span class="footer-meta">Unique Entity Number: 202643218C</span>
        <span class="footer-meta">Registered Address: 71 UBI ROAD 1, #08-34, OXLEY BIZHUB, SINGAPORE 408732</span>
        <span class="footer-meta footer-en">
          Registered Office: 71 UBI ROAD 1, #08-34, OXLEY BIZHUB, SINGAPORE 408732
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
